import { render, staticRenderFns } from "./CentralBotVsHumanSection.vue?vue&type=template&id=088e9604&scoped=true"
import script from "./CentralBotVsHumanSection.vue?vue&type=script&lang=js"
export * from "./CentralBotVsHumanSection.vue?vue&type=script&lang=js"
import style0 from "./CentralBotVsHumanSection.vue?vue&type=style&index=0&id=088e9604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088e9604",
  null
  
)

export default component.exports